import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { HttpService } from 'src/app/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
declare var jQuery: any;
declare var $: any;
import * as moment from 'moment';
import { CanonicalService } from '../../shared/canonical.service';

function ValidateEmail(control: AbstractControl): { [key: string]: Boolean } | null {

  // let regularExp = /^([\w.-]+)@(\[(\d{1,3}\.){3}|(?!hotmail|gmail|yahoo|outlook)(([a-zA-Z\d-]+\.)+))([a-zA-Z]{2,4}|\d{1,3})(\]?)$/;
  let regularExp = /^([\w.-]+)@((?!hotmail|gmail|yahoo|outlook)([a-zA-Z\d-]+\.)+)([a-zA-Z]{2,4}|\d{1,3})(\]?)$/;
  if (control.value !== undefined && !regularExp.test(control.value)) {
    return { "isValidEmail": true };
  }
  return null;
}

@Component({
  selector: 'app-app-protectt',
  templateUrl: './app-protectt.component.html',
  styleUrls: ['./app-protectt.component.css']
})
export class AppProtecttComponent implements OnInit {

  @ViewChild('closebutton') closebutton: any;
  subscribeForm: FormGroup;
  demoForm: FormGroup;
  public message: any;
  cilentIPAddress = '';
  demoSubmitted = false;
  submittedSub = false;
  href = "";
  innerWidth: number = window.innerWidth;
  currentRoutePath: any;
  routeid:any;
  heading = "Enhance Your Mobile App Security Effortlessly";
  subheading = "With Our Innovative Runtime Application Self Protection (RASP) enabled Mobile App Security Platform";

  slides = [
    { img: "http://placehold.it/350x150/000000" },
    { img: "http://placehold.it/350x150/111111" },
    { img: "http://placehold.it/350x150/333333" },
    { img: "http://placehold.it/350x150/000000" },
    { img: "http://placehold.it/350x150/111111" },
    { img: "http://placehold.it/350x150/333333" },
    { img: "http://placehold.it/350x150/666666" }
  ];
  slideConfig = { "slidesToShow": 4, "slidesToScroll": 1, "autoplay": true, "autoplaySpeed": 1500, "dots": true };

  addSlide() {
    this.slides.push({ img: "http://placehold.it/350x150/777777" })
  }

  removeSlide() {
    this.slides.length = this.slides.length - 1;
  }

  slickInit() {
  }

  breakpoint() {
  }

  afterChange() {
  }

  beforeChange() {
  }
  constructor(private titleService: Title, private metaTagService: Meta, private metaTagService1: Meta, public fb: FormBuilder, private http: HttpClient, public router: Router, private httpService: HttpService, private canonicalService: CanonicalService, private route: ActivatedRoute) {

    this.canonicalService.setCanonicalURL("https://www.protectt.ai/appprotectt");
    // console.log(this.router.url);
    this.currentRoutePath = this.router.url;
    this.httpService.getIPAddress().subscribe((res: any) => {
      this.cilentIPAddress = res.ip;
    });

    this.subscribeForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]{1,64}@[a-z0-9.-]+\\.[a-z]{2,4}$'), ValidateEmail])],
    });
    this.demoForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]{1,64}@[a-z0-9.-]+\\.[a-z]{2,4}$'), ValidateEmail])],
      name: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.pattern('^[A-Za-z ]+$')])],
      designation: ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
      message: [''],
      contactnumber: ['', Validators.compose([Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")])],
      company_name: ['', Validators.compose([Validators.required])],
      time_slot1: ['', Validators.compose([Validators.required])],
      time_slot2: [''],
    });
  }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params =>{
      if(params['action']=="true"){
        $("#modalContactForm").modal('show');
      }
    })

    this.titleService.setTitle('All In One Mobile App Security For iOS and Android Business Apps');
    this.metaTagService1.updateTag({ name: 'title', content: 'All In One Mobile App Security For iOS and Android Business Apps' });
    this.metaTagService.updateTag({ name: 'description', content: 'Check out the all in one best mobile security for your  iOS and Android business & Mobile banking apps. We not only secure your data we also provide Network Security, Safeguarding your Apps, Cyber Security and much more. Contact Now!' });
  }

  dataLeft: any =
    [
      {
        "parentName": "Reverse Engineering",
        "childProperties":
          [
            { "propertyName": "Reverse Engineering allows hackers to analyse a compiled app and extract information about its source code. They can then leverage the source code to execute an attack, access proprietary information, expose vulnerabilities or repack and redistribute a malicious version to a targeted victim. Your source code is at the core of your business operations and App Protectt acts as the first line of defence in safeguarding it against threats." },

          ]
      },
      {
        "parentName": "Spoofing",
        "childProperties":
          [
            { "propertyName": "Mobile apps are susceptible to sophisticated spoofing attacks which allow other apps to assume the identity of the original app. Hackers exploit this technique to gain control of users’ sensitive login information or transactional details. App Protectt prevents a malicious app from gaining control and detects whether any app installed is harmful to your business application." },
          ]
      },
      {
        "parentName": "Debugging",
        "childProperties":
          [
            { "propertyName": "App Protectt adds anti-debugging protection to your meticulously developed app that secures it from debugging tools that may attempt to read your source code. It blocks native and Java debugging tools from attaching to your iOS or Android app and actively detects any dynamic injection code manipulations performed during run-time." },
          ]
      },
      {
        "parentName": "Man in The Middle (MiTM) Attacks",
        "childProperties":
          [
            { "propertyName": "In today’s privacy-focused world, the safety of user data is vital. With the increasing flow of data between end-users and your app server, Man-in-The-Middle (MiTM) attacks try to gain access to and preview information within a secured communication channel. App Protectt safeguards your private communications and sensitive information against such malicious attacks." },
          ]
      },
      {
        "parentName": "Compromised Devices",
        "childProperties":
          [
            { "propertyName": "Jailbroken iOS and Rooted Android smartphones are a breeding ground for mobile malware that is equipped to enable escalated special access to control a device and the operating system which is otherwise not allowed. App Protectt is configured to detect whether your app is being executed on a compromised device and mitigate the risks of an insecure environment." },
          ]
      }
    ]

  dataRight: any =
    [
      {
        "parentName": "Screen Mirroring",
        "childProperties":
          [
            { "propertyName": "Screen mirroring can allow attackers to visually see the credentials an end-user is entering without him knowing about it. By monitoring the keystrokes of your end users’ device screen lock pattern or the passcode of a banking app, attackers can easily replicate the existing authentication protocols. App Protectt’s proprietary behaviour analysis can identify any screen mirroring on a user’s device and alert them in real-time." },

          ]
      },
      {
        "parentName": "SMS Attacks",
        "childProperties":
          [
            { "propertyName": "With SMS continuing to be the primary mode of authentication, hackers are always on the lookout for opportunities to exploit this lesser secure channel of communication. This malpractice is particularly common in consumer-facing sectors to compromise device binding or gain access to OTPs. Protectt.ai’s proprietary technology helps organisations to prevent threats rising from these exploits when authenticating end users." },
          ]
      },
      {
        "parentName": "Unsecured Device Binding",
        "childProperties":
          [
            { "propertyName": "In today’s fast-paced world of digital transactions, device binding is key to speeding up the authentication process on users’ mobile devices. Banking and finance apps regularly use phone numbers and device signatures as identification factors for this authentication. App Protectt safeguards your end-user from being tricked into losing their identity to a malicious attacker by falling prey to social engineering attacks launched from your business app." },
          ]
      },
      {
        "parentName": "Hooking",
        "childProperties":
          [
            { "propertyName": "Hooking is an increasing threat in mobile apps as hackers attempt to intercept and manipulate the run-time business logic of your app without the need to access the source code. Bypassing the business logic can result in a loss of revenue for your organisation and increases the risk for data and financial fraud of your users. App Protectt hardens and protects your mobile app and hinders any external tampering of your original function logic." },
          ]
      },
      {
        "parentName": "End to End Encryption",
        "childProperties":
          [
            { "propertyName": "App Protectt’s advanced encryption standards protect your iOS or Android app by enabling robust data protection and preventing any breaches or malicious infiltrations. Secure your app with unique encryption using dynamic in-app, app-specific cryptography and threat aware encryption keys. App Protectt encryption is optimised for powerful performance at encryption and decryption ensuring a smooth user experience." },
          ]
      }
    ]
  isExpand = false;
  onClick() {
    this.isExpand = !this.isExpand;

    console.log(this.isExpand, 'clicked')
  }


  myFunction(btnid: any) {
    var elem = jQuery("#" + btnid + "-btn")[0].innerHTML;
    if (elem == "Read More ↓") {
      jQuery("#" + btnid + "-btn")[0].innerHTML = "Read Less ↑";
      jQuery("." + btnid).slideDown();
      jQuery('.' + btnid + '.dots').hide();
    } else {
      jQuery("#" + btnid + "-btn")[0].innerHTML = "Read More ↓";
      jQuery("." + btnid).slideUp();
      jQuery('.' + btnid + '.dots').show();
    }
  }

  submitDemoForm() {
    let dateString1 = this.demoForm.get('time_slot1')!.value;
    let dateString2 = this.demoForm.get('time_slot2')!.value;
    var dateTimeSlot1 = moment(dateString1).format('DD-MM-YYYY HH:MM');
    var dateTimeSlot2 = moment(dateString2).format('DD-MM-YYYY HH:MM');
    let url = environment.API_URL + "requestdemo";
    let urlValue = "";
    this.demoSubmitted = true;
    if (this.demoForm.invalid) {
      return;
    } else {
      if (url.includes("dev.website")) {
        urlValue = "nonprod"
      } else {
        urlValue = "prod"
      }
      var demoData = {
        email: this.demoForm.get('email')!.value,
        name: this.demoForm.get('name')!.value,
        designation: this.demoForm.get('designation')!.value,
        message: this.demoForm.get('message')!.value,
        contactnumber: this.demoForm.get('contactnumber')!.value,
        companyname: this.demoForm.get('company_name')!.value,
        timeslot1: dateTimeSlot1,
        timeslot2: dateTimeSlot2,
        ipaddress: this.cilentIPAddress,
        weburl: urlValue,
        adcampurl: this.currentRoutePath
      };
      let data = {
        salesLeadData: demoData,
      }
      let encryptMsg = JSON.stringify(data);
      let encMsg = this.httpService.encryptText(encryptMsg, HttpService.SECRET_KEY);
      let postData = {
        encryptedRequest: encMsg
      }

      this.httpService.postAPIMethod(url, postData).subscribe(
        res => {
          let decRes = this.httpService.decryptText(res, HttpService.SECRET_KEY);
          let decMsg = decRes;
          let resp: any = JSON.parse(decMsg);
          alert(resp['statusDesc']);
          // this.subRespData = JSON.parse(decMsg);
        },
        error => {
        });


      this.demoSubmitted = false;
      // alert("Request has been submitted..");
      this.closebutton.nativeElement.click();
    }
  }

  onReset() {

    this.message = '';
    this.demoForm.reset();
    this.subscribeForm.reset();
    this.demoSubmitted = false;
    this.submittedSub = false;
  }

  get getDemoForm() {
    return this.demoForm.controls;
  }
  onResize(event: any) {
    this.innerWidth = event.target.innerWidth;
  }

}
